import { render, staticRenderFns } from "./ErrorLabel.vue?vue&type=template&id=100d6e54"
import script from "./ErrorLabel.vue?vue&type=script&lang=js"
export * from "./ErrorLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports